<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const projectTypeOptions = [
        `Résidentiel`,
        `Commercial`,
        `Bureau`,
        `Hôtel et restaurant`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const servicesOptions = [
        `Conception de plans`,
        `Décoration intérieure`,
        `Agencement et travaux`,
        `Menuiserie sur mesure`,
        `Visualisations 3D`,
        `Conseil en design`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const styleOptions = [
        `Moderne`,
        `Classique`,
        `Minimaliste`,
        `Luxe`,
        `Ethnique`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.architectesInterieur.projectType}
        class=""
        let:field
        let:id
        label={`Quel type de projet d'aménagement intérieur envisagez-vous ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={projectTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.architectesInterieur.services}
        class=""
        let:field
        let:id
        label={`Quels services recherchez-vous principalement ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={servicesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.architectesInterieur.style}
        class=""
        let:field
        let:id
        label={`Quel style ou ambiance recherchez-vous ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[300px]:grid-cols-2 @[500px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={styleOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
